function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(29.187 13.723)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 174.85 260.88)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-6.083 25.816-28.22-2.975s4.896-17.017 1.467-30.062c-1.572-5.98-12.83-14.976-16.931-22.982-2.205-4.304 43.542 9.609 43.542 9.609l8.23 5.494 0.368 3.599c0.613 6.001-0.663 5.595-2.373 11.501",
  fill: "#1ad3af"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 158.98 271.97)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.412 0-3.468-0.838-5.024-0.436-0.846 0.218-4.097 2.178-4.097 2.178 2.186 2.711 16.589 23.784 16.589 23.784 3.093 3.904 5.694 6.046 9.59 5.924 8.255-0.26 9.918-3.902 11.528-7.422l0.287-0.626s-8.919-7.56-14.034-12.113c-5.744-5.115-11.169-9.946-13.032-10.925-0.503-0.261-1.121-0.364-1.807-0.364",
  fill: "#fc5f00"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 176.98 265.4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.118 0.777-0.186 1.632-0.25 2.451-0.18 2.263-0.29 3.604-1.039 4.157-0.7 0.515-1.95 0.277-2.663-0.038-1.725-0.763-2.356-2.939-2.954-5.077-0.645-2.312-1.256-4.497-3.008-4.826-3.57-0.677-8.183 1.765-10.956 5.799-0.256 0.37-0.484 0.753-0.684 1.15l-0.538 1.069-0.746-0.936c-0.154-0.191-15.397-19.244-23.466-23.168-1.08-0.518-6.735-2.064-12.555-1.159-3.641 0.561-4.332 1.532-4.436 1.722-0.146 0.271-0.399 0.463-0.693 0.527-0.293 0.058-0.585-3e-3 -0.82-0.178-0.64-0.476-2.408-1.071-4.454-1.76-5.89-1.982-14.792-4.977-14.967-11.077-0.237-8.698 0.999-9.462 16.538-10.215 1.457-0.07 2.89-0.103 4.293-0.103 11.296 0 20.626 2.151 24.455 4.541 3.044 1.912 10.008 3.691 18.825 5.945 2.615 0.667 5.383 1.376 8.242 2.136 11.382 3.018 11.836 4.404 12.008 4.927 0.052 0.16 0.064 0.325 0.039 0.479 0.115 1.624 1.051 15.568-0.171 23.634",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 177.18 269.98)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.307 0.942-5.769-0.767-15.977-4.31-5.633-1.954-11.458-3.974-15.71-4.92-1.14-0.253-2.275-0.728-3.591-1.278-4.2-1.756-14.12-5.292-30.152-5.292-1.798 0-1.967 0.883-14.384 3.144-0.887 0.157-1.79-0.119-2.62-0.806-1.322-1.099-2.363-3.249-2.37-4.896-0.044-8.873 0.883-9.445 16.535-10.2 1.462-0.072 2.896-0.105 4.302-0.105 11.283 0 20.61 2.158 24.44 4.554 3.062 1.913 10.08 3.704 18.965 5.969 2.574 0.658 5.295 1.351 8.104 2.097 11.38 3.02 11.836 4.406 12.009 4.929 0.052 0.16 0.066 0.323 0.042 0.476 0.058 0.762 0.339 4.606 0.407 9.209 6e-3 0.394 0 1.429 0 1.429",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 157.53 273.29)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.286 0-2.628 0.085-3.978 0.295-5.339 0.825-5.753 2.677-5.753 3.225v0.334l4.731 4.41c3.182 2.749 6.487 7.235 8.147 9.445 3.69 4.913 8.573 12.602 8.573 12.602l1.178-0.598c2.186-0.854 0.545-2.905 0.113-3.724-1.841-3.482-13.301-17.51-16.199-19.687-0.696-0.523 3.195-1.649 4.189-1.302 1.403 0.489 8.616 7.525 12.275 11.767 5.296 6.143 10.771 12.493 13.607 13.253 2.375 0.644 4.576-0.377 6.065-2.791l0.079-0.151c0.157-0.362 0.313-0.672 0.496-0.981l0.106-0.181 0.015-0.524-0.168-0.21c-0.633-0.795-15.613-19.516-23.998-23.593-1.069-0.512-4.929-1.589-9.478-1.589",
  fill: "#a83f0b"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 166.98 264.59)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.041 0-0.084 1e-3 -0.127 7e-3l-16.778 1.803c-0.642 0.07-1.109 0.648-1.04 1.292 0.07 0.644 0.641 1.102 1.292 1.04l16.778-1.804c0.642-0.07 1.108-0.648 1.04-1.292-0.066-0.601-0.574-1.046-1.165-1.046",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 165.89 265.74)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.036 0-0.073 1e-3 -0.109 4e-3l-16.063 1.485c-0.646 0.061-1.119 0.631-1.06 1.275 0.06 0.646 0.628 1.109 1.274 1.061l16.064-1.486c0.645-0.06 1.119-0.631 1.06-1.274-0.057-0.609-0.568-1.065-1.166-1.065",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 164.57 266.93)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.046 0-0.092 3e-3 -0.137 7e-3l-14.501 1.697c-0.644 0.076-1.104 0.658-1.029 1.301 0.076 0.644 0.677 1.078 1.3 1.028l14.502-1.697c0.643-0.075 1.103-0.658 1.028-1.3-0.07-0.597-0.576-1.036-1.163-1.036",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 163.45 268.14)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.047 0-0.096 3e-3 -0.145 9e-3l-13.784 1.698c-0.642 0.079-1.099 0.664-1.02 1.306 0.08 0.643 0.66 1.101 1.306 1.02l13.785-1.698c0.642-0.079 1.098-0.664 1.02-1.306-0.073-0.594-0.578-1.029-1.162-1.029",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 162.4 269.39)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.054 0-0.11 3e-3 -0.166 0.011l-13.382 1.905c-0.641 0.091-1.088 0.684-0.996 1.325s0.677 1.09 1.325 0.996l13.382-1.905c0.641-0.091 1.087-0.684 0.996-1.325-0.083-0.585-0.585-1.007-1.159-1.007",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 161.65 270.55)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.056 0-0.113 4e-3 -0.17 0.011l-13.93 2.026c-0.641 0.093-1.085 0.689-0.992 1.33 0.095 0.641 0.687 1.078 1.329 0.991l13.93-2.026c0.641-0.093 1.085-0.688 0.992-1.329-0.086-0.584-0.587-1.003-1.159-1.003",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 160.33 271.52)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.057 0-0.115 4e-3 -0.172 0.013l-13.057 1.92c-0.641 0.093-1.083 0.69-0.989 1.329 0.092 0.641 0.696 1.089 1.329 0.989l13.058-1.92c0.641-0.093 1.083-0.69 0.988-1.329-0.084-0.583-0.585-1.002-1.157-1.002",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 203.98 252.39)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 10.289-28.33c0.844-3.272 0.9-5.73 0.981-7.563l0.604-13.678 31.357-2.343s-0.5 15.86-2.137 20.678c-1.959 5.767-9.069 28.663-9.069 28.663z",
  fill: "#1ad3af"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 220.76 276.6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.175 0.573-40.069-2.084-0.186-0.141c-0.404-0.302-2.42-2.404-2.475-14.067-8e-3 -1.673 0.283-3.221 0.862-4.602 0.978-2.338 2.568-3.791 4.6-4.197 1.569-0.313 3.443-0.417 5.349-0.417 2.199 0 10.821 0.072 12.107 0.062 3.898-0.027 9.485 0.27 12.422 1.005l1.12 0.276c3.319 0.811 5.939 1.452 7.218 3.418 1.271 1.957 1.31 13.334-0.773 20.174",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 211.31 281.44)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-4.503 0-9.499 0.503-12.078 2.436-4.29 3.218-1.698 10.551 0.193 15.905 0.561 1.584 1.044 2.953 1.206 3.844 0.69 3.803 1.132 12.761 1.138 12.881 0 0 0.182 5.807 6.533 6.279 1.318 0.098 2.548-0.343 2.788-0.364 0.635-0.032 5.557 0.375 6.379 0.384 3.975 0.071 9.492 1.57 13.512-2.952 1.247-1.405 3.264-3.934 4.198-11.419 0.328-2.628 0.363-3.677 0.963-5.383 0.21-0.596 0.443-1.263 0.698-2.092 0.786-2.572 2.429-9.05 0.689-13.636-1.683-4.435-15.485-5.218-17.054-5.292-0.299-0.041-4.462-0.591-9.165-0.591",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 212.26 277.45)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-4.101 0-7.439 3.338-7.439 7.439v22.477c0 1.359 0.913 2.535 2.221 2.855 1.138 0.28 3.033 0.645 5.598 0.798 2.889 0.174 5.523-0.367 7.227-0.853 1.37-0.391 2.259-1.707 2.115-3.13l-2.321-22.899c-0.386-3.812-3.568-6.687-7.401-6.687",
  fill: "#fc5f00"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.1 278.66)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.238 0-0.478 0.013-0.717 0.043-2.905 0.355-6.111 0.442-9.525 0.265-1.743-0.091-3.439 0.608-4.606 1.92-1.157 1.301-1.651 3.032-1.358 4.748 0.398 2.329 0.81 4.735 1.032 6.352 0.392 2.887 0.156 11.828 0.036 15.538-0.045 1.375 0.453 3.143 1.397 3.925 2.238 1.855 5.396 0.7 5.528 0.67l0.615-0.127-0.16-24.766c-1e-3 -0.301 0.114-0.584 0.327-0.797 0.211-0.214 0.494-0.331 0.795-0.331h1.511c0.56 0 1.027 0.403 1.109 0.957l3.04 25.044 0.432 0.165c1.517 0.584 5.316 1.209 7.048-1.957 0.743-1.358-0.705-14.224-0.802-14.748-0.286-1.553-0.172-4.344-0.061-7.042 0.058-1.399 0.116-2.815 0.125-4.124 0.012-1.629-0.678-3.185-1.894-4.268-1.066-0.95-2.447-1.467-3.872-1.467",
  fill: "#a83f0b"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 275.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 274.43)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 273.19)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 271.95)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 270.71)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 269.47)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 214.54 268.22)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-13.913c-0.647 0-1.172 0.525-1.172 1.172s0.525 1.172 1.172 1.172h13.913c0.647 0 1.172-0.525 1.172-1.172s-0.525-1.172-1.172-1.172",
  fill: "#13000f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 177.79 50.422)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c2.036 18.378 28.714 17.688 33.351 0.541 2.643-9.771 10.55-24.067 19.179-33.597 8.629-9.529 19.313-28.685 14.745-49.318-4.258-19.233-18.373-26.793-35.632-27.578s-14.031 5.958-27.456 5.958c-13.426 0-31.212 15.453-19.133 24.03 12.08 8.576 14.946 79.964 14.946 79.964",
  fill: "#ff7201"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 179.73 48.794)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c5.43 0.225 14.584-2.983 16.661-10.847 3.384-12.813-0.37-17.88-4.092-20.122-1.552-0.935-3.692-2.093-5.661-3.125-2.752-1.443-1.599 16.487-1.599 16.487s-8.727 17.465-5.309 17.607",
  fill: "#1500e4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 167.75 81.927)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h34.771l2.054 28.953-36.825-1.295z",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 165.78 63.703)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c1.738-1.384 3.674-1.151 3.759-1.132l0.671 0.088-0.168 15.144-0.726 0.028c-0.148 5e-3 -0.384 6e-3 -0.681-0.022-0.908-0.086-2.383-0.439-3.608-1.736-1.451-1.533-2.041-3.841-1.755-6.86 0.238-2.52 1.083-4.374 2.508-5.51",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 167.03 59.984)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-2.04 4e-3 -2.185-1.987c-0.146-1.991 0.199-3.934 0.199-3.934s0.966 1.117 1.986 0 0 5.921 0 5.921",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 165.85 62.16)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.393 2.187-1.572 4.239-0.546 6.271 1.105 2.192 4.214 2.313 4.345 2.318l0.014-0.467c-0.029-1e-3 -2.962-0.118-3.944-2.06-0.956-1.9-0.791-3.746 0.524-5.812z",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 180.36 50.162)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-3.093 3.133-7.851 4.591-14.978 4.591-17.247 0-19.436-8.775-22.272-25.559-2.616-15.474-1.438-39.832-0.328-44.929 1.68-7.71 10.395-9.554 20.209-9.618 0.121-1e-3 0.175 0.233 0.296 0.233 10.716 0 16.694 9.612 18.021 12.954 2.179 5.487 3.7 24.362 3.709 31.297 1e-3 2.081 0.027 4.09 0.052 6.02 0.142 11.165 0.255 19.983-4.709 25.011",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 180.14 59.349)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-0.718-9.168 0.549-11.238c1.268-2.07 2.07-2.263 2.07-2.263l1.557 14.688z",
  fill: "#ff7201"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 181.06 49.463)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-3.962 4.816-9.536 7.614-16.566 7.464-16.032-0.34-23.883-6.854-25.165-26.905-0.191-2.998 1.485-9.002 1.643-9.561 0 0 0.49 5.324 1.917 6.559 3.636 3.149 22.046-1.472 30.92 7.257 2.282-8.49 0.117-12.231 9.766-16.383l3.712-5.03 0.18 1.028c0.178 1.001 3.917 23.021-6.407 35.571",
  fill: "#ff7201"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 178.54 54.975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.53 0.058 5.779 17.578 0.172-0.212z",
  fill: "#ffd1de"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 182.48 60.754)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.599 1.541-3.549 1.491-3.636 1.481l-0.676-0.025-0.106-1.27-1.153-13.822 0.72-0.096c0.146-0.019 0.382-0.043 0.68-0.043 0.912 0 2.413 0.214 3.755 1.389 1.589 1.39 2.394 3.632 2.394 6.664 0 2.532-0.666 4.457-1.978 5.722",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 181.01 65.663)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.24 0-0.475 0.016-0.698 0.045l-0.854 0.113 1.27 15.225 0.28-0.023-1.247-14.959 0.588-0.08c0.211-0.027 0.433-0.041 0.661-0.041 0.543 0 1.375 0.08 2.251 0.459l0.113-0.256c-0.922-0.399-1.794-0.483-2.364-0.483",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 181.66 64.474)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.075 0-0.144 0.028-0.198 0.082-0.124 0.124-0.095 0.31-0.055 0.459 0.175 0.648 0.111 1.161-0.188 1.524-0.666 0.81-2.282 0.704-2.3 0.704l-0.033 0.464c0.07 0.011 1.873 0.124 2.692-0.87 0.346-0.419 0.463-0.961 0.352-1.615 0.517 0.588 1.413 1.926 1.659 2.857 0.546 2.072 0.389 3.735-0.467 4.943-1.242 1.748-3.569 1.949-3.593 1.951l0.037 0.464c0.104-7e-3 2.562-0.216 3.933-2.142 0.944-1.325 1.124-3.12 0.541-5.334-0.318-1.207-1.795-3.34-2.293-3.475-0.029-7e-3 -0.058-0.012-0.087-0.012",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 180.88 61.151)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s2.199-0.227 2.083-2.734c-0.115-2.507-2.502-2.287-2.502-2.287z",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 169.51 60.417)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c1.579 0 1.581 2.453 0 2.453-1.579 0-1.581-2.453 0-2.453",
  fill: "#603813"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 175.09 60.85)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c1.579 0 1.581 2.453 0 2.453-1.579 0-1.581-2.453 0-2.453",
  fill: "#603813"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 171.15 68.395)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.781 0.185-0.705 1.117-0.705 1.117l3.346 24.91c0.094 0.5 0.651 0.856 1.261 0.798 0.44-0.042 1.064-0.383 1.015-1.101l-3.346-24.91s-0.312-1.113-1.571-0.814",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 171.17 68.315)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.989-0.24 1.266 0.56 1.293 0.651l3.34 24.877c0.04 0.617-0.568 0.815-0.807 0.838-0.508 0.058-0.938-0.227-1.009-0.609l-3.345-24.897c-2e-3 -0.017-0.046-0.724 0.528-0.86m0.353-0.511c-0.142 0-0.295 0.018-0.462 0.058-0.771 0.183-0.914 0.971-0.884 1.362l3.35 24.922c0.118 0.636 0.799 1.063 1.513 0.999 0.634-0.06 1.278-0.554 1.227-1.348l-3.349-24.926c-0.116-0.421-0.539-1.067-1.395-1.067",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 171.19 71.6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,0 C -0.264,0 -0.534,0.011 -0.814,0.036 -3.997,0.313 -5.32,2.051 -5.374,2.124 -5.675,2.53 -5.591,3.104 -5.183,3.406 -4.781,3.702 -4.212,3.623 -3.91,3.225 -3.865,3.168 -2.956,2.061 -0.654,1.86 2.397,1.583 4.223,3.263 4.3,3.335 4.668,3.68 5.247,3.661 5.593,3.298 5.939,2.932 5.928,2.357 5.564,2.009 5.473,1.92 3.426,0 0,0",
  fill: "#ff6985"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 176.28 58.709)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-8.226v0.599c0 1.355 1.099 2.454 2.454 2.454h8.825c0-1.686-1.367-3.053-3.053-3.053",
  fill: "#ff7201"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 171.63 58.488)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-7.391 0.84c-1.675 0.19-2.878 1.703-2.687 3.378l7.39-0.84c1.675-0.19 2.879-1.703 2.688-3.378",
  fill: "#ff7201"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 173.24 77.136)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-11.578 0-15.51 5.634-15.577 5.694l4e-3 0.293c0.069-0.062 4.871-5.996 17.214-5.395 9.897 0.492 18.357 8.996 19.485 13.544l-0.116-1.93c-1.494-3.351-9.487-12.475-21.01-12.206",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 275.78 114.91)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c3.959-1.943 6.03-2.163 10.236-3.489l21.795-6.87c3.199-1.008 5.133 0.467 4.852 2.442-0.14 0.983-0.978 2.137-3.584 3.233-4.196 1.764-11.095 4.24-16.98 6.288 0.017 0.05 0.033 0.098 0.049 0.15l23.831-5.632c3.264-0.771 5.085 0.841 4.66 2.79-0.211 0.971-1.132 2.061-3.812 2.962-5.611 1.889-15.87 4.645-22.437 6.362 0.05 0.136 0.106 0.286 0.166 0.448l25.835-3.377c3.325-0.435 4.972 1.354 4.351 3.25-0.309 0.944-1.336 1.934-4.093 2.559-5.958 1.348-16.929 3.111-23.594 4.138 0.073 0.169 0.124 0.279 0.137 0.277l20.471-1.627c3.336-0.347 4.935 1.484 4.266 3.363-0.334 0.936-1.386 1.899-4.159 2.451-8.993 1.791-27.286 2.802-27.286 2.802l10.661 2.895c2.115 0.439 3.341 2.172 2.767 3.878-0.655 1.946-3.066 2.542-5.012 1.886l-12.8-3.021c-2.654-0.627-5.245-1.492-7.743-2.585l-5.419-2.372-14.766 0.183-1.056-15.037 14.59-5.483z",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 276.81 111.01)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 0,0 c -2.349,0 -4.575,0.842 -6.596,2.519 -0.164,0.136 -0.186,0.38 -0.049,0.544 0.136,0.164 0.378,0.189 0.544,0.051 C -2.81,0.381 1.084,0.042 5.15,2.137 8.594,3.906 9.756,9.638 9.769,9.695 9.809,9.903 10,10.045 10.222,10 10.432,9.958 10.568,9.755 10.526,9.546 10.477,9.295 9.277,3.388 5.504,1.449 3.622,0.482 1.776,0 0,0",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 279.82 114.26)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.071 0-0.142 0.019-0.206 0.06-0.18 0.114-0.235 0.352-0.122 0.533 4.189 6.655 4.686 18.229 4.691 18.345 8e-3 0.213 0.181 0.399 0.401 0.371 0.213-8e-3 0.381-0.188 0.372-0.402-0.019-0.482-0.51-11.897-4.808-18.726-0.075-0.116-0.201-0.181-0.328-0.181",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 96.44 24.76)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-3.531 2.642-4.67 4.385-7.765 7.527l-16.034 16.282c-2.354 2.39-1.92 4.783-0.034 5.432 0.939 0.323 2.348 0.102 4.51-1.721 3.48-2.934 8.824-7.949 13.325-12.258l0.112 0.112-15.859 18.657c-2.172 2.556-1.565 4.911 0.364 5.42 0.961 0.254 2.35-0.07 4.372-2.046 4.236-4.138 11.358-12.019 15.875-17.086 0.098 0.107 0.206 0.224 0.324 0.352l-14.764 21.468c-1.9 2.764-1.056 5.044 0.914 5.354 0.982 0.155 2.331-0.309 4.142-2.481 3.912-4.691 10.473-13.659 14.421-19.126 0.117 0.142 0.191 0.238 0.184 0.248l-10.764 17.489c-1.827 2.812-0.924 5.07 1.054 5.328 0.985 0.129 2.321-0.37 4.075-2.588 5.687-7.193 14.911-23.022 14.911-23.022l-2.273 10.811c-0.571 2.083 0.414 3.963 2.194 4.228 2.031 0.302 3.658-1.573 3.96-3.604l3.134-12.774c0.65-2.648 1.059-5.349 1.222-8.071l0.354-5.905 6.881-13.065-12.909-7.783-11.522 10.498z",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 101.35 23.751)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.051 0-0.102 0.01-0.153 0.032-4.236 1.819-6.469 5.377-6.456 10.288 9e-3 4.24 4.724 7.998 4.924 8.157 0.168 0.131 0.41 0.102 0.543-0.065 0.131-0.169 0.102-0.411-0.065-0.544-0.046-0.036-4.621-3.686-4.63-7.55-0.011-4.577 2.06-7.889 5.99-9.576 0.197-0.084 0.286-0.311 0.202-0.508-0.062-0.146-0.206-0.234-0.355-0.234",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 95.303 20.941)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.067 0-0.135 0.018-0.199 0.055-0.182 0.109-0.242 0.347-0.132 0.53 4.124 6.934 14.066 12.567 14.487 12.803 0.187 0.107 0.42 0.04 0.526-0.147s0.038-0.422-0.147-0.527c-0.102-0.057-10.184-5.769-14.204-12.525-0.071-0.122-0.2-0.189-0.331-0.189",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 159.59 116.24)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 6.511-21.705h89.611l1.24 24.186z",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 161.89 81.846)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 69.966-8.713 19.954-72.787 2.481-6.547v-17.106l-100.44-0.943-10.773 90.595 1.443 16.134z",
  fill: "#410eac"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 175.77 81.846)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s25.144-0.539 49.33-8.713c24.185-8.173 74.256-26.011 97.362-32.358 29.841-8.199 130.84-27.481 130.84-27.481l-3.683-24.939-116.97 17.363c-9.376 1.456-18.647 3.52-27.755 6.179l-74.836 19.957 0.668-48.548-43.212 3.516c-6.923 0.672-11.563 2.353-11.747 8.916z",
  fill: "#1ad3af"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 105.56 22.025)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c18.699-26.673 52.027-72.014 79.69-97.91 40.929-38.316 101.33-73.518 101.33-73.518l-0.484-82.615c-0.225-5.922-1.197-11.544-9.168-12.341l-27.462-2.736-0.808 24.871-0.325 9.994-1.285 39.543s-45.77 33.574-89.911 78.778c-24.078 24.657-72.403 100.76-72.403 100.76z",
  fill: "#1ad3af"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 184.54 81.025)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-4.84 5.007-11.958 4.853-11.958 4.853s-3.063-6.192-16.798-6.392c-4.582-0.074-9.576 0.103-13.349 1.189-2.319 0.667-5.274 2.296-5.494 4.69v2.408s-11.81-3.997-13.307-9.117c-0.508-1.734-0.154-3.441 1.049-5.072 4.358-5.905 10.665-1.682 13.628 0.438-0.197-1.899-0.078-4.469 1.231-6.48 1.131-1.736 2.916-2.75 5.303-3.013 0.452-0.05 0.887-0.074 1.308-0.074 5.835 1e-3 8.636 4.595 9.863 7.713 1.062-3.175 3.419-7.598 9.729-7.061 2.646 0.222 4.64 1.178 5.926 2.842 0.899 1.162 1.832 3.199 1.539 6.592 2.209-2.984 4.704-3.956 6.507-4.224 2.799-0.423 5.11 0.637 6.343 1.762 1.602 1.464 1.962 5.344-1.52 8.946",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 179.7 104.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-7.088h0.017c0.088-1.97 1.7-3.543 3.692-3.543 1.991 0 3.603 1.573 3.692 3.543h0.033c0.089-1.97 1.701-3.543 3.692-3.543s3.603 1.573 3.692 3.543h0.034c0.088-1.97 1.7-3.543 3.691-3.543 1.992 0 3.604 1.573 3.692 3.543h0.034c0.089-1.97 1.7-3.543 3.692-3.543 1.991 0 3.603 1.573 3.692 3.543h0.017v7.088z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 155.88 104.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-7.088h0.017c0.088-1.97 1.7-3.543 3.692-3.543 1.991 0 3.603 1.573 3.692 3.543h0.033c0.089-1.97 1.701-3.543 3.692-3.543 1.992 0 3.603 1.573 3.692 3.543h0.034c0.088-1.97 1.7-3.543 3.692-3.543 1.991 0 3.603 1.573 3.691 3.543h0.034c0.089-1.97 1.7-3.543 3.692-3.543 1.991 0 3.603 1.573 3.692 3.543h0.017v7.088z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 168.53 89.155)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.858-0.695-1.553-1.553-1.553s-1.554 0.695-1.554 1.553 0.696 1.553 1.554 1.553 1.553-0.695 1.553-1.553",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 168.53 94.023)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.858-0.695-1.553-1.553-1.553s-1.554 0.695-1.554 1.553 0.696 1.553 1.554 1.553 1.553-0.695 1.553-1.553",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 168.53 98.89)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.858-0.695-1.553-1.553-1.553s-1.554 0.695-1.554 1.553 0.696 1.553 1.554 1.553 1.553-0.695 1.553-1.553",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 168.53 103.76)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.858-0.695-1.553-1.553-1.553s-1.554 0.695-1.554 1.553 0.696 1.553 1.554 1.553 1.553-0.695 1.553-1.553",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 168.53 108.63)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.858-0.695-1.553-1.553-1.553s-1.554 0.695-1.554 1.553 0.696 1.553 1.554 1.553 1.553-0.695 1.553-1.553",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 98.618 28.023)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.599 0.95 21.064 14.913 0.648-0.915z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 98.985 28.59)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.598 0.932 21.134 14.963 0.647-0.916z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 99.356 29.166)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.616 0.956 21.207 15.005 0.652-0.921z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 99.73 29.746)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.609 0.942 21.27 15.066 0.652-0.918z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 273.03 105.9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 1.102-0.211-3.715-24.968-1.109 0.165z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 272.36 105.78)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 1.102-0.212-3.728-25.048-1.109 0.165z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 271.69 105.65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 1.102-0.212-3.74-25.13-1.109 0.165z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 271.01 105.52)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 1.102-0.213-3.752-25.212-1.109 0.164z",
  fill: "#009245"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 193.5 122.15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s20.155-21.085 22.635-58.293c2.481-37.209 5.581-138.98 8.062-154.49 2.481-15.503 45.522-180.29 45.522-180.29h-40.803s-56.016 162.93-60.099 190.21c-3.382 22.602-14.075 103.74-18.346 131.08h-3.566l-40.184-132.84 37.794-183.69-41.174-0.078-47.835 174.49c-1.166 4.801-1.105 9.818 0.177 14.589l46.656 199.31z",
  fill: "#1289c4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 159.87 133.47)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.554 0-1.026 0.421-1.08 0.982-0.056 0.597 0.381 1.127 0.977 1.184 8.385 0.802 15.981 5.592 20.317 12.813l3.405 5.672c0.308 0.513 0.973 0.68 1.49 0.371 0.514-0.308 0.679-0.975 0.372-1.489l-3.406-5.672c-4.689-7.808-12.903-12.989-21.97-13.856-0.036-3e-3 -0.07-5e-3 -0.105-5e-3",
  fill: "#0c73bf"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 192.94 133.64)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.026 0-0.051 1e-3 -0.076 3e-3l-6.691 0.463c-9.387 0.898-18.053 6.207-22.648 13.858l-3.408 5.672c-0.307 0.514-0.142 1.181 0.372 1.49 0.517 0.309 1.18 0.141 1.49-0.372l3.407-5.672c4.247-7.072 12.28-11.982 20.965-12.812l6.662-0.462c0.599-0.041 1.049-0.56 1.009-1.157-0.04-0.573-0.517-1.011-1.082-1.011",
  fill: "#0c73bf"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 200.61 138)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-8.425 3.416-0.113 0.274-12.192 29.925h8.681v-1.399h-6.601l11.296-27.725 7.878-3.194z",
  fill: "#0c73bf"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 176.44 144.08)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-7.926 51.106 1.843 0.286 7.926-51.106z",
  fill: "#0c73bf"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 19.753 252.22)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-4.491-58.489 31.296-1.064 3.83 71.162z",
  fill: "#66a617"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 17.031 276.26)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-3.348-2.043-3.725-7.364-3.437-9.92 0.093-0.823 0.728-1.478 1.546-1.608 11.944-1.909 54.418-2.967 81.714-1.127 9.463 0.638 22.955 2.139 16.9 15.201-0.326 0.704-0.352 1.02-1.111 0.86-14.651-3.082-95.612-3.406-95.612-3.406",
  fill: "#050c60"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 18.607 276.99)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-2.634 0.291-4.725 2.364-5.014 4.997-0.72 6.574 0.843 16.168 3.643 20.528 0 0 8.091-2.075 10.302-5.672 1.442-2.345 8.898-2 12.546 0.466 7.213 4.875 10.274 10.274 16.394 6.995s22.649-14.264 30.081-16.45c7.432-2.185 23.472-1.037 23.69-6.938 0.219-5.902-0.874-7.869-8.087-8.306-1.578-0.096-4.85-0.085-9-0.095-24.082-0.061-48.084 1.551-71.994 4.192z",
  fill: "#dfb043"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 35.845 278.37)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-2.347 3.839-6.204 7.466-10.576 10.091-4.261 2.56-8.585 3.513-14.177 3.461l-14.307-0.549c-3.363 0.072-4.919 0.982-7.149 2.643l-0.997-4.749c0.023-0.017 0.046-0.033 0.068-0.049 2.776-1.978 6.109-3.015 9.515-2.914l10.375 0.556c8.335 0.563 13.426-1.036 18.457-6.1 0.683-0.688 1.954-2.056 1.954-2.056z",
  fill: "#050c60"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 19.931 271.94)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.505 5.479-5.942 7.861-6.896 7.271-2.554-5.67-2.761-13.527-1.439-19.049 0.309-1.292 1.406-2.242 2.726-2.388l13.736-1.517c-2.146 1.99-7.706 11.116-8.127 15.683",
  fill: "#ff4608"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 40.31 273.91)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-29.478 18.801c-0.779 0.475-2.377 4.058-1.902 4.836 0.475 0.779 2.205-0.536 2.984-1.01l33.161-20.231z",
  fill: "#dfb043"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 28 268.32)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c6.999-5.11 30.63-19.494 34.943-17.541 3.359 1.521 5.257 2.764 6.386 3.844-1.411 0.483-3.104 1.226-4.963 2.134-1.365-0.772-2.859-1.315-4.088-0.996-1.933 0.501-18.703 10.958-25.689 15.345-0.707 0.445-1.595 0.515-2.348 0.153-1.374-0.661-2.746-1.693-4.241-2.939",
  fill: "#ff4608"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 47.891 273.91)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-2.146-3.499-7.006-3.333c-7.066 0.242-12.014 1.586-18.637-6.772-1.137-1.435 28.009 1.032 28.009 1.032l5.385 2.644v3.629s-0.669 1.852-7.751 2.8",
  fill: "#ba1f32"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 50.186 274.55)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.288-2.224-5.151-4.527-15.968-4.671-5.681-0.075-13.499-0.365-16.179-3.631-0.951-1.159-0.951-1.159-1.974-2.797 1.62-0.174 24.365-0.507 28.193-0.275 7.213 0.437 8.306 2.405 8.088 8.306-0.045 1.216-0.956 2.608-2.16 3.068",
  fill: "#e0320a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 21.248 270.06)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c3.309-2.791 11.449-3.245 16.435-0.116 8.202 5.146 8.204 9.488 15.424 6.21 1.361-0.618 15.17-8.194 17.301-9.259-3.798 2.252-16.272 9.819-18.337 10.926-6.121 3.278-6.68 1.798-15.171-4.45-3.416-2.513-9.129-3.966-14.307-0.53-3.517 2.334-7.558 5.311-10.327 3.534-0.217-0.14-0.79-1.703-0.79-2.133 3.841 0.748 6.563-1.475 9.772-4.182",
  fill: "#ff4608"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 33.707 267.72)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.629-0.423 1.056-0.63 0.633-1.259l-3.202-4.632c-0.423-0.629-1.276-0.795-1.904-0.372-0.629 0.423-0.796 1.276-0.373 1.905l3.202 4.632c0.423 0.629 1.015 0.149 1.644-0.274",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 31.702 266.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.629-0.423 1.056-0.63 0.633-1.258l-3.202-4.633c-0.423-0.629-1.276-0.795-1.904-0.372-0.629 0.423-0.796 1.276-0.373 1.905l3.202 4.632c0.423 0.629 1.015 0.149 1.644-0.274",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 35.486 268.77)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.645-0.398 1.081-0.587 0.683-1.232l-3.013-4.757c-0.398-0.645-1.243-0.846-1.889-0.449-0.645 0.398-0.846 1.243-0.448 1.889l3.013 4.757c0.398 0.645 1.009 0.19 1.654-0.208",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 37.264 269.88)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.645-0.398 1.081-0.587 0.683-1.232l-2.693-4.54c-0.397-0.645-1.243-0.846-1.888-0.448-0.645 0.397-0.846 1.243-0.448 1.888l2.692 4.54c0.398 0.645 1.009 0.19 1.654-0.208",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 39.223 271.07)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.645-0.398 1.081-0.587 0.683-1.232l-2.437-4.221c-0.398-0.645-1.243-0.846-1.889-0.448-0.645 0.397-0.845 1.243-0.448 1.888l2.437 4.221c0.398 0.645 1.009 0.19 1.654-0.208",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 3.8675 250.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-3.142-58.879-25.533-0.838 0.922 59.027z",
  fill: "#66a617"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 4.3153 276.14)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s0.839 6.122 0 10.338-2.482 10.542-3.325 12.65c0 0 0.965 1.598-4.879-2.5s-11.316-7.892-16.458-6.957c-5.143 0.935-10.253 6.957-10.253 6.957s-3.486-5.408-7.278-13.038c-3.487-7.014-10.304-16.771-10.304-16.771l-1.958-2.394 18.648-10.128 17.013 2.686 19.167 12.791z",
  fill: "#dfb043"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -.15266 281.06)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-4.497 4.944-9.887 4.643c-5.39-0.3-9.97-3.661-16.772-3.564-7.933 0.114-12.767 1.479-12.762 4.115 0 0-1.47-1.214-2.369-2.945s-0.637-5.061-0.637-5.061l9.63-6.456 15.98-0.37 10.688 4.445z",
  fill: "#7e2305"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -.69143 280.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-3.834 2.593-4.935 2.587c-5.302-0.028-10.758-5.11-13.935-5.45-3.177-0.341-12.497-0.549-15.886 0.403-3.389 0.951-4.904 4.106-4.904 4.106s-3.7-5.458-3.886-10.332c-0.167-4.375 4.863-4.44 4.863-4.44l22.399-0.597 11.767 6.212z",
  fill: "#e0320a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -.92027 280.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.417 1.506c-0.111 0.401-2.504 9.681 3.458 14.424 5.835 4.642 7.513 11.028 7.552 11.092l1.877-1.174c-0.169-0.27-2.041-7.693-7.855-12.457-3.471-2.844-3.158-6.79-2.763-9.401l0.746 0.521 1.267-1.815z",
  fill: "#050c60"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 3.4606 268.91)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-4.107-2.513-4.657-7.464 0.464-3.558-0.224-8.784-3.376-8.544-2-11.295l9.304 7.055s1.57 7.437 0.483 12.49c-1.087 5.052-2.906 7.998-2.906 7.998",
  fill: "#ff4608"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 4.5434 274.61)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s1.617-0.71 1.791-3.602c0.093-1.541 0.439-5.17 0.413-7.544-0.026-2.318-1.402-4.31-3.421-5.451-3.841-2.172-7.399-3.367-9.259-4.313-1.581-0.803-6.627-4.456-8.058-6.77-1.125-1.821-2.808-3.134-4.57-4.35-3.637-2.509-9.134-3.751-14.129-3.657-9.221 0.174-18.91 0.803-19.954 2.021-0.34 0.397-0.68 1.07-0.984 1.798-0.785 1.881-0.932 3.969-0.46 5.952l0.246 0.528s1.591-0.622 3.679 0.031c2.088 0.652 1.581 4.547 7.194 4.569 5.565 0.022 6.491-0.771 8.653-3.472 2.113-2.642 9.115-2.558 11.377-1.097 2.261 1.46 7.319 9.388 12.994 13.293 6.126 4.216 9.43 7.653 14.488 12.064",
  fill: "#050c60"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 .14183 270.45)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-0.785-1.031 0.618 0.838c0.717 0.954 2.498 0.434 4.239 2.036 1.741 1.601 3.648 4.004 3.648 4.004s0.052 0.339-0.034 0.836c-0.097 0.557-0.71 0.842-1.2 0.558-0.317-0.184-0.677-0.435-1.005-0.762-0.835-0.836-1.544-2.214-2.639-3.132-0.857-0.717-3.625-0.088-6.406-2.595s-1.394-2.432-1.394-2.432z",
  fill: "#ff4608"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -.0511 269.73)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-15.43-24.629-20.009-26.088c-4.578-1.459-11.163 1.648-11.736 3.286-0.572 1.637 1.66 9.589 4.805 15.172s4.615 12.534 7.55 14.891c2.936 2.356 7.334 4.235 11.53 2.433 4.195-1.801 9.337-3.209 7.86-9.694",
  fill: "#dfb043"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 .35992 270.16)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-17.53-23.947-22.108-25.406-11.083-0.802-11.909 0.723c-1.872 3.456 3.008 14.26 5.843 20.006 1.972 3.995 4.044 7.965 4.044 7.965 0.694 1.793 5.849 2.863 7.641 2.146 0 0-12.228-20.331-10.932-22.779 0.739-1.397 1.353-1.479 3.081-0.398 2.904 1.815 14.203 23.329 16.72 23.108 3.125-0.275 7.989-3.744 7.62-5.365",
  fill: "#ff4608"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -6.2481 276.74)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,0 C -0.021,0 -0.041,0 -0.062,0.002 L -12.2,0.798 c -0.508,0.033 -0.893,0.472 -0.86,0.98 0.033,0.509 0.459,0.903 0.981,0.86 L 0.06,1.842 C 0.567,1.809 0.953,1.37 0.919,0.861 0.887,0.374 0.481,0 0,0",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -5.3557 274.94)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,0 C -0.021,0 -0.041,0 -0.062,0.002 L -12.2,0.798 c -0.508,0.033 -0.893,0.472 -0.86,0.98 0.034,0.508 0.463,0.917 0.981,0.86 L 0.06,1.842 C 0.567,1.809 0.953,1.37 0.919,0.861 0.887,0.374 0.481,0 0,0",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -4.463 273.13)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.021 0-0.041 0-0.062 2e-3l-12.139 0.796c-0.507 0.033-0.893 0.472-0.859 0.98 0.033 0.508 0.467 0.91 0.98 0.86l12.14-0.796c0.507-0.033 0.893-0.472 0.859-0.981-0.032-0.487-0.438-0.861-0.919-0.861",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -3.2009 271.34)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.021 0-0.041 0-0.061 2e-3l-13.187 0.864c-0.508 0.033-0.893 0.472-0.859 0.981 0.032 0.508 0.47 0.9 0.98 0.859l13.187-0.864c0.507-0.033 0.893-0.472 0.859-0.981-0.032-0.487-0.438-0.861-0.919-0.861",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -1.8675 269.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.026 0-0.053 1e-3 -0.08 3e-3l-14.436 1.238c-0.508 0.044-0.884 0.49-0.84 0.998 0.043 0.507 0.492 0.873 0.997 0.84l14.437-1.238c0.507-0.044 0.883-0.49 0.84-0.998-0.042-0.481-0.444-0.843-0.918-0.843",
  fill: "#3235ba"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 28.935 132.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-110.16 3.564 6.127-367.82h37.254l13.636 308.62 18.989-115.62 0.525-193.11h41.707l9.569 168.99c0.909 16.055 0.474 32.158-1.3 48.14z",
  fill: "#201f99"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 .54234 139.77)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.798 0-1.625 0.056-2.486 0.175-12.579 1.734-18.597 4.038-18.847 4.136-0.514 0.2-0.769 0.778-0.569 1.293 0.199 0.515 0.779 0.77 1.294 0.571 0.059-0.024 6.083-2.321 18.395-4.02 5.88-0.807 10.804 1.525 14.647 6.937 2.93 4.128 4.087 8.54 4.098 8.584 0.137 0.534 0.68 0.857 1.218 0.72 0.535-0.138 0.856-0.683 0.719-1.218-0.047-0.182-4.59-17.178-18.469-17.178",
  fill: "#031756"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 24.578 141.23)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-3.078 0-6.517 0.185-10.071 0.713-9.362 1.391-9.07 17.741-9.053 18.436 0.014 0.552 0.504 0.976 1.023 0.976 0.553-0.014 0.989-0.472 0.976-1.024-3e-3 -0.153-0.273-15.277 7.348-16.41 11.329-1.683 21.759 0.276 21.864 0.296 0.541 0.1 1.067-0.252 1.17-0.794 0.105-0.542-0.251-1.066-0.793-1.171-0.305-0.058-5.443-1.022-12.464-1.022",
  fill: "#031756"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 10.587 149.22)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.082 0-0.165 0.01-0.247 0.031-0.535 0.136-0.859 0.68-0.723 1.215 0.059 0.235 5.963 23.73 5.585 42.963-0.011 0.552 0.428 1.009 0.981 1.02 0.567-0.01 1.008-0.428 1.019-0.981 0.383-19.507-5.586-43.257-5.647-43.494-0.114-0.453-0.522-0.754-0.968-0.754",
  fill: "#031756"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 16.77 260.75)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.035 12.727c-1e-3 0.453 0.366 0.821 0.819 0.821h42.573c0.471 0 0.844-0.395 0.818-0.865l-0.721-12.727c-0.025-0.433-0.383-0.772-0.817-0.772h-41.819c-0.451 0-0.817 0.365-0.818 0.816",
  fill: "#4b6c87"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -7.8178 255.97)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h37.855c0.529 0 0.951-0.441 0.927-0.969l-0.491-12.404c-0.022-0.496-0.431-0.887-0.928-0.887h-37.153c-0.507 0-0.92 0.406-0.929 0.913l-0.209 12.403c-9e-3 0.519 0.409 0.944 0.928 0.944",
  fill: "#4b6c87"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 80.835 -5.7006)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.71 0.984-3.895 0.395-4.878-1.313l-8.145-14.148-0.079 0.046 10.246 20.676c0.876 1.768 0.153 3.911-1.615 4.787-1.765 0.876-3.911 0.155-4.787-1.615l-10.046-20.272-0.348 0.201 9.983 22.669c0.795 1.805-0.024 3.913-1.829 4.709-1.803 0.794-3.913-0.023-4.709-1.83l-9.671-21.958-0.572 0.33 7.765 20.313c0.705 1.843-0.218 3.908-2.061 4.612-1.842 0.705-3.906-0.219-4.612-2.061l-11.85-30.997-2.939 13.621c-0.419 1.929-2.334 3.162-4.246 2.736-1.929-0.417-3.153-2.318-2.736-4.246l3.674-16.985 1.657-11.68 0.9-7.277-0.405-8.63 24.383-0.95 0.768 7.927 17.465 36.457c0.985 1.709 0.397 3.893-1.313 4.878",
  fill: "#ffc3c8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 70.079 8.6039)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.126 0-0.251 0.058-0.333 0.167-0.136 0.183-0.098 0.442 0.086 0.579 3.965 2.945 6.76 9.788 4.363 15.706-2.072 5.113-8.554 6.569-8.62 6.584-0.223 0.048-0.365 0.268-0.317 0.491 0.049 0.223 0.268 0.365 0.491 0.317 0.284-0.061 6.974-1.557 9.212-7.081 2.58-6.369-0.331-13.483-4.636-16.681-0.074-0.056-0.161-0.082-0.246-0.082",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 75.861 2.0886)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.09 0-0.18 0.029-0.256 0.089-7.474 5.917-18.68 7.985-18.792 8.005-0.225 0.041-0.374 0.256-0.334 0.481s0.257 0.373 0.48 0.334c0.114-0.021 11.52-2.123 19.159-8.171 0.18-0.142 0.21-0.402 0.068-0.581-0.082-0.103-0.203-0.157-0.325-0.157",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -1.5624 -12.188)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-17.482-38.001-1.464-7.339 14.995-9.226 6.456 3.478 10.484 5.408 15.977 6.835c1.813 0.775 2.656 2.874 1.879 4.688-0.759 1.807-2.874 2.655-4.689 1.879l-12.809-5.486 18.419 27.604c1.094 1.641 0.653 3.859-0.988 4.954s-3.86 0.653-4.954-0.989l-12.071-18.089-0.6 0.275 12.309 20.596c1.013 1.694 0.458 3.888-1.233 4.899-1.694 1.012-3.887 0.46-4.899-1.234l-12.708-21.262-0.365 0.168 10.717 19.926c0.936 1.738 0.282 3.906-1.454 4.838-1.737 0.935-3.904 0.284-4.839-1.454l-10.93-20.322-0.083 0.038 6.823 14.83c0.824 1.791 0.039 3.913-1.753 4.738s-3.914 0.04-4.738-1.752",
  fill: "#ffc3c8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -4.7639 4.3458)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.219 0-0.402 0.172-0.413 0.394-0.221 4.581 2.011 10.802 9.03 13.257 5.432 1.899 11.785-1.199 12.053-1.332 0.205-0.102 0.289-0.35 0.187-0.554-0.101-0.205-0.348-0.289-0.554-0.187-0.062 0.03-6.315 3.076-11.413 1.292-6.589-2.304-8.684-8.14-8.476-12.436 0.011-0.228-0.165-0.423-0.393-0.434h-0.021",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 2.9225 -.47596)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,0 C -0.094,0 -0.187,0.031 -0.265,0.096 -0.357,0.173 -9.59,7.8 -18.908,9.824 c -0.223,0.049 -0.364,0.269 -0.316,0.492 0.049,0.224 0.269,0.367 0.492,0.317 C -9.213,8.564 0.171,0.81 0.265,0.731 0.44,0.585 0.464,0.324 0.318,0.149 0.236,0.051 0.118,0 0,0",
  fill: "#f15a24"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 76.576 8.9937)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-32.263 1.478c-9e-3 -0.634-10.193-95.054-37.159-139.73-17.977-29.782-55.13-49.159-80.696-57.425 0 0-23.854-2.509-41.745 2.099-22.493 9.358-51.453 27.399-62.714 47.625-13.222 23.749-8.405 54.262-1.178 75.395 13.981 40.885 35.628 75.96 35.628 75.96l-25.709 13.246s-79.638-81.559-45.421-178.78c8.286-23.545 28.104-44.48 52.419-65.148l-9.93-107.44c-0.068-3.701 1.11-6.789 4.807-6.981l111.47-9.785c3.44-0.134 5.688 2.876 5.912 6.508 1.233 19.989 3.309 65.79 6.69 106.88 38.998 16.729 72.268 49.702 87.295 74.595 33.196 54.996 32.554 158.42 32.597 161.5",
  fill: "#dfb400"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -10.185 128.67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 115.27-9.711s0.242-10.502 0-15.703c-0.066-1.415-1.292-2.491-2.703-2.376l-110.25 8.917c-2.34 0.19-4.078 2.246-3.867 4.585 0.344 3.812 0.904 9.527 1.558 14.288",
  fill: "#bc820d"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 65.194 8.4723)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 32.263-1.478-0.351-16.495-33.976 1.55s1.172 8.886 2.064 16.423",
  fill: "#bc820d"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -10.15 2.4145)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 25.709-13.246s-7.736-13.504-8.803-15.497l-28.897 14.371s10.053 13.046 11.991 14.372",
  fill: "#bc820d"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 9.5391 93.427)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.765 0.121 1.411 20.607 1.765-0.121z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 16.579 95.914)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.765 0.121 1.412 20.618 1.764-0.121z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 19.108 94.082)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.765 0.121 1.411 20.607 1.765-0.121z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 14.05 97.746)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.765 0.121 1.411 20.609 1.765-0.12z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 11.795 95.583)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.765 0.121 1.411 20.609 1.765-0.12z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 27.633 56.591)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.587 1.897-3.752 2.074-3.848 2.073l-1.591 0.113-0.166-1.481-2.187-15.137 0.786-0.192c0.16-0.039 0.417-0.093 0.748-0.128 1.009-0.109 2.697-0.052 4.322 1.09 1.925 1.349 3.083 3.735 3.444 7.092 0.302 2.803-0.206 5.013-1.508 6.57",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 26.534 60.65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.083-3e-3 -0.161 0.026-0.224 0.083-0.143 0.133-0.118 0.342-0.079 0.509 0.169 0.728 0.078 1.296-0.269 1.689-0.773 0.874-2.566 0.693-2.587 0.692l-0.055 0.516c0.077 0.015 2.079 0.211 3.03-0.863 0.401-0.452 0.552-1.051 0.455-1.784 0.552 0.675 1.496 2.2 1.733 3.245 0.527 2.328 0.287 4.172-0.713 5.482-1.451 1.896-4.049 2.029-4.075 2.03l0.022 0.518c0.116-4e-3 2.86-0.139 4.462-2.229 1.102-1.438 1.373-3.428 0.811-5.915-0.307-1.355-1.866-3.787-2.414-3.956-0.032-0.01-0.065-0.016-0.097-0.017",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 25.531 56.983)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s2.456-0.166 2.426-2.96-2.694-2.643-2.694-2.643z",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 6.5462 56.591)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c1.587 1.897 3.752 2.074 3.848 2.073l1.591 0.113 0.166-1.481 2.187-15.137-0.786-0.192c-0.159-0.039-0.417-0.093-0.748-0.128-1.009-0.109-2.697-0.052-4.322 1.09-1.925 1.349-3.083 3.735-3.444 7.092-0.302 2.803 0.206 5.013 1.508 6.57",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 7.645 60.65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.083-3e-3 0.161 0.026 0.224 0.083 0.143 0.133 0.118 0.342 0.079 0.509-0.169 0.728-0.078 1.296 0.269 1.689 0.773 0.874 2.566 0.693 2.587 0.692l0.055 0.516c-0.077 0.015-2.079 0.211-3.03-0.863-0.401-0.452-0.552-1.051-0.455-1.784-0.552 0.675-1.496 2.2-1.733 3.245-0.527 2.328-0.287 4.172 0.713 5.482 1.451 1.896 4.049 2.029 4.075 2.03l-0.022 0.518c-0.116-4e-3 -2.86-0.139-4.462-2.229-1.102-1.438-1.373-3.428-0.811-5.915 0.307-1.355 1.866-3.787 2.414-3.956 0.032-0.01 0.065-0.016 0.097-0.017",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 8.6479 56.983)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0s-2.456-0.166-2.426-2.96 2.694-2.643 2.694-2.643z",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 24.77 64.463)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-5.534-31.328-36.895 2.438-1.604 30.669h0.011c0.681-4.151 1.274-6.007 1.274-6.007 2.889-10.547 10.04-19.037 18.77-19.037h4.81c8.718 0 16.071 10.648 18.52 20.256 0 0 0.275 1.054 0.648 3.009",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 17.811 73.297)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-3.448c-8.944 0-17.162 6.684-20.315 16.385 0 0-0.059 2.682-0.158 3.035l0.952-1.674 1.003 0.282c2.62-9.322 10.235-15.832 18.518-15.832h3.448c6.586 0 13.004 4.797 16.353 12.219l1.397-0.547-0.424-2.404c-3.913-7.032-10.518-11.464-17.326-11.464",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 8.3194 54.05)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7e-3 -0.556c0.19-14.637 1.225-24.13 2.059-29.514 0.679-4.481 1.266-6.494 1.288-6.571 2.819-10.028 11.087-17.033 20.105-17.033h3.447c8.857 0 17.105 7.728 19.612 18.378 0.01 0.047 0.271 1.18 0.642 3.284 0.969 5.381 2.6 16.622 2.633 31.462l1e-3 0.55z",
  fill: "#ffc8d5"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 28.2 52.374)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-1.599-0.6-3.042-1.578-4.092s-2.334-1.694-3.824-1.694l-50.959-0.159c-3.857 0-6.234 2.754-6.234 5.951 0 1.611 0.852 3.048 1.83 4.098s2.323 1.694 3.824 1.694h51.539c2.99 0 5.402-2.589 5.402-5.798",
  fill: "#ff5b25"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 8.1125 50.716)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.14 0-2.212-0.478-3.02-1.345-0.573-0.615-1.535-1.868-1.535-3.349 0-2.338 1.607-4.853 5.136-4.853l50.955 0.158c1.143 0 2.216 0.478 3.024 1.345 0.828 0.888 1.283 2.076 1.283 3.344 0 2.592-1.93 4.7-4.303 4.7zm0.584-11.744c-4.183 0-7.335 3.031-7.335 7.05 0 1.655 0.754 3.377 2.125 4.846 1.227 1.318 2.87 2.044 4.626 2.044h51.54c3.584 0 6.5-3.093 6.5-6.896 0-1.825-0.665-3.545-1.873-4.841-1.228-1.318-2.872-2.044-4.627-2.044z",
  fill: "#ff5b25"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 25.549 50.313)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.633 13.497-10.961 21.098-23.739 20.838-12.078-0.245-24.768-6.242-24.768-20.535l0.305-0.348z",
  fill: "#ff5b25"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 17.402 43.347)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.207 0-0.415-2e-3 -0.623-6e-3 -10.731-0.219-23.23-5.26-23.68-18.687l46.22 0.043c-1.055 11.263-9.698 18.65-21.917 18.65m-25.605-20.89-0.906 1.032v0.414c0 6.895 2.876 12.577 8.318 16.431 4.542 3.218 10.765 5.065 17.525 5.202 14.279 0.303 24.231-8.505 24.858-21.885l0.055-1.148z",
  fill: "#ff5b25"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 25.549 50.617)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-48.656c-0.451 0-0.817 0.366-0.817 0.817s0.366 0.817 0.817 0.817h48.656c0.451 0 0.817-0.366 0.817-0.817s-0.366-0.817-0.817-0.817",
  fill: "#f44d25"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 19.368 66.919)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-1.425-3.015-3.496-6.562-3.496s-6.282 2.071-6.282 3.496z",
  fill: "#ff6b76"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 18.202 64.53)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-6.232l0.85 22.222h4.532z",
  fill: "#ffadb7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 22.032 56.69)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-1.819-1.608-3.46-3.591-3.46s-3.591 1.641-3.591 3.46",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 21.332 56.69)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.888-0.72-1.607-1.607-1.607-0.888 0-1.607 0.719-1.607 1.607s0.719 1.607 1.607 1.607c0.887 0 1.607-0.719 1.607-1.607",
  fill: "#6b3203"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 14.706 56.69)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-1.819-1.608-3.46-3.591-3.46s-3.591 1.641-3.591 3.46",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 14.007 56.69)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.888-0.72-1.607-1.607-1.607-0.888 0-1.607 0.719-1.607 1.607s0.719 1.607 1.607 1.607c0.887 0 1.607-0.719 1.607-1.607",
  fill: "#6b3203"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 24.483 56.955)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.318 0-0.613 0.204-0.714 0.523-0.125 0.395 0.093 0.816 0.487 0.942 0.026 8e-3 2.587 0.847 3.775 2.96 0.202 0.361 0.66 0.49 1.021 0.286 0.361-0.203 0.49-0.66 0.286-1.022-1.484-2.64-4.502-3.614-4.63-3.654-0.075-0.024-0.15-0.035-0.225-0.035",
  fill: "#044829"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 9.7658 56.955)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-0.074 0-0.15 0.011-0.225 0.035-0.128 0.04-3.146 1.014-4.631 3.654-0.203 0.361-0.075 0.819 0.286 1.022 0.361 0.204 0.819 0.075 1.022-0.286 1.196-2.129 3.748-2.951 3.773-2.96 0.395-0.124 0.615-0.545 0.49-0.94-0.1-0.32-0.396-0.525-0.715-0.525",
  fill: "#044829"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 20.766 58.205)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-2.368 0-4.295 1.927-4.295 4.295s1.927 4.295 4.295 4.295 4.294-1.927 4.294-4.295-1.926-4.295-4.294-4.295m-20.766 0c-2.369 0-4.295 1.927-4.295 4.295s1.926 4.295 4.295 4.295c2.368 0 4.295-1.927 4.295-4.295s-1.927-4.295-4.295-4.295m31.305 5.395h-4.145c-0.525 3.058-3.189 5.395-6.394 5.395-3.065 0-5.634-2.136-6.313-4.995h-8.14c-0.68 2.859-3.249 4.995-6.313 4.995-3.206 0-5.87-2.337-6.395-5.395h-4.145c-0.607 0-1.1-0.493-1.1-1.1s0.493-1.1 1.1-1.1h4.145c0.525-3.058 3.189-5.395 6.395-5.395 3.064 0 5.633 2.135 6.313 4.995h8.14c0.679-2.86 3.248-4.995 6.313-4.995 3.205 0 5.869 2.337 6.394 5.395h4.145c0.607 0 1.1 0.493 1.1 1.1s-0.493 1.1-1.1 1.1",
  fill: "#044829"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 9.7217 56.862)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v0.973l2.309-0.479z",
  fill: "#bdccd4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 24.483 56.862)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v0.973l-2.309-0.479z",
  fill: "#bdccd4"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 17.624 78.76)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-10.102 0-18.633 2.138-24.936 4.079-3.694 1.138-5.767 5.056-4.629 8.751 1.138 3.694 5.056 5.767 8.751 4.629 8.044-2.479 20.395-5.352 34.724-1.723 3.748 0.948 7.555-1.319 8.504-5.067 0.949-3.747-1.319-7.555-5.067-8.504-6.159-1.56-11.975-2.165-17.347-2.165",
  fill: "#bc820d"
})));

function SvgStudentDasboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "322.28mm",
    height: "300.92mm",
    viewBox: "0 0 322.28 300.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDasboard);
export default __webpack_public_path__ + "static/media/student-dasboard.c7eada0d.svg";
export { ForwardRef as ReactComponent };